import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import { Upload } from '@progress/kendo-react-upload'
import Papa from 'papaparse'
import Paper from '../theme/Paper'
import ArrowForwardIcon from '@material-ui/icons/ArrowForward'
import ReactSelect from 'components/theme/Select'
import Table from '@material-ui/core/Table'
import { groupOptionsSelector } from 'selectors'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Button from '@material-ui/core/Button'
import Hidden from '@material-ui/core/Hidden'
import Lens from '@material-ui/icons/Lens'
import language from 'utils/vast-languagepack'
import Fuse from 'fuse.js'
import { bulkUpload } from 'actions/contacts'
import { getAllGroups, createGroup } from 'actions/contacts/groups'
import { list, create } from 'actions/data'
import LinearProgress from '@material-ui/core/LinearProgress'
import * as chrono from 'chrono-node';

const styles = (theme) => ({
  header: {
    width: 18,
  },
})

const mapStateToProps = (state) => ({
  bulkUploadInProgress: state.contacts.bulkUploadInProgress,
  bulkUploadStatus: state.contacts.bulkUploadStatus,
  groupOptions: groupOptionsSelector(state),
  groupsByID: state.contacts.groupsByID,
  assignmentPools: Object.values(state.data['account/ap'] || {}).map((pool) => ({
    value: pool.id.toString(),
    label: pool.name,
    key: `${pool.id}PoolSelectValue`
  })),
  assignmentPoolsById: state.data?.['account/ap'] || {}
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      bulkUpload,
      getAllGroups,
      createGroup,
      list,
      create
    },
    dispatch,
  )

const VastFields = [
  {
    field: 'FULL_NAME',
    text: 'Full Name',
    sample: 'Abraham Lincoln.  You can combine multiple fields from your spreadsheet.',
    synonym1: 'Name',    
  },
  {
    field: 'FIRST_NAME',
    text: language.contacts.add.firstNameReg,
    sample: 'Abraham',
    synonym1: 'f_name',
    synonym2: 'name',
    synonym3: 'first',
  },
  {
    field: 'MIDDLE_NAME',
    text: language.contacts.add.middleName,
    sample: 'Honest',
    synonym1: 'm_name',
  },
  {
    field: 'LAST_NAME',
    text: language.contacts.add.lastNameReg,
    sample: 'Lincoln',
    synonym1: 'l_name',
    synonym2: 'last',
  },
  {
    field: 'PHONE',
    text: language.contacts.add.mobilePhoneButton,
    sample: '+1940212922',
    synonym1: 'cellphone',
  },
  {
    field: 'EMAIL',
    text: language.contacts.add.mobileEmailButton,
    sample: 'potus@whitehouse.gov',
  },
  {
    field: 'LOCATION',
    text: language.contacts.add.location,
    sample: 'Washington, DC. You can combine multiple fields from your spreadsheet.',
    synonym1: 'Address',
    synonym2: 'zip',
  },
  {
    field: 'NOTES',
    text: language.contacts.add.notes,
    sample: 'The 16th President of the United States of Americas. You can combine multiple fields from your spreadsheet ',
    synonym1: 'description',
  },
  {
    field: 'ACCEPTS_MARKETING',
    text: 'Accepts Marketing',
    sample: 'Yes, No, True, False, Y, N T, F, 1, 0, on, off',
    synonym1: 'opt-in',
    synonym2: 'subscribed',
  },
  {
    field: 'VASTUSER',
    text: 'User Assignment',
    sample: 'It must contain a valid Vast Reach username. Otherwise the contact will be assigned via assignment pool or remain unassigned if there is no default assignment pool.',
    synonym1: 'user',
    synonym2: 'owner',
    synonym3: 'assigned',
  },
  {
    field: 'WHEN_STARTED',
    text: 'When Started',
    sample: 'This field is a date that represents when the contact first became a contact for your business outside of Vast Reach.',
    synonym1: 'date',
    synonym2: 'created',
    synonym3: 'created_date',
  },
]
const startState = {
  file: undefined,
  parsedFile: undefined,
  map: {},
  selectedGroup: undefined,
  selectedAssignmentPool: undefined,
  concat_map: {
    LOCATION: [],
    NOTES: [],
    FULL_NAME: []
  },
}

class BulkUploadMapper extends Component {
  state = startState

  componentDidMount() {
    console.log('smartRouter Mounted')
    this.props.getAllGroups()
    this.props.list('account/ap')

    if (this.props.uploadToGroupId) {
      this.setState({
        ...this.state,
        uploadToGroupId: {
          value: this.props.uploadToGroupId
        }
      })
    }
  }
  onAdd = (event) => {
    console.log('onAdd: ', event.affectedFiles)
    const TheFile = event.affectedFiles[0].getRawFile()
    this.setState({
      ...this.state,
      file: TheFile,
    })
    const that = this
    Papa.parse(TheFile, {
      delimiter: '', // auto-detect
      newline: '', // auto-detect
      quoteChar: '"',
      escapeChar: '"',
      header: true,
      transformHeader: undefined,
      dynamicTyping: false,
      preview: 0,
      encoding: '',
      worker: false,
      comments: false,
      step: undefined,
      complete: function (res) {
        console.log(res)
        that.setState({
          ...that.state,
          parsedFile: res,
        })
      },
      error: undefined,
      download: false,
      downloadRequestHeaders: undefined,
      skipEmptyLines: false,
      chunk: undefined,
      fastMode: undefined,
      beforeFirstChunk: undefined,
      withCredentials: undefined,
      transform: undefined,
      delimitersToGuess: [',', '\t', '|', ';', Papa.RECORD_SEP, Papa.UNIT_SEP],
    })
  }

  onRemove = (event) => {
    console.log('onRemove: ', event.affectedFiles)

    this.setState({
      files: event.newState,
    })
  }

  onProgress = (event) => {

    this.setState({
      files: event.newState,
    })
  }
  submitFile = () => {
    const { parsedFile, map, concat_map, file, selectedGroup, selectedAssignmentPool } = this.state;

    let headers = parsedFile.meta ? parsedFile.meta.fields : []
    const mapped = parsedFile.data.map((row) => {
      let newRow = {
        ...row
      }

      const mapFields = Object.keys(map)
      mapFields.map((vastField) => {
        console.log("mapFields.map.Vastfield", vastField)
        let concat = ''
        concat_map[vastField] &&
          concat_map[vastField].map((item) => {
            concat += ` ${row[item.value]}`
           
            console.log("concat",concat)

            return null
            
          })

        if (map[vastField].value) {
         

          if (vastField === "WHEN_STARTED") {
            console.log("***WHEN_STARTED:", row[map[vastField].value])
            const when_started = new Date(chrono.parseDate(row[map[vastField].value]))
            console.log(when_started.toISOString())
            newRow = {
              ...newRow,
              [vastField]: (when_started.toISOString() + ' ' + concat.trim()).trim(),
            }
          }else{
            newRow = {
              ...newRow,
              [vastField]: (row[map[vastField].value] + ' ' + concat.trim()).trim(),
            }
          }
         
        }

        delete newRow[map[vastField].value]
        return newRow
      })
      headers = Object.keys(newRow)
      return newRow;
    });
    if (mapped[0]) headers = Object.keys(mapped[0])

    parsedFile.meta.fields = headers
    parsedFile.data = mapped
    const csv_string = Papa.unparse(mapped, {
      quotes: false,
      quoteChar: '"',
      escapeChar: '"',
      delimiter: ',',
      header: true,
      newline: '\r\n',
      skipEmptyLines: true,
      columns: headers,
    })
    const theFile = new File([csv_string], file.name, { type: 'text/csv' })
    if (selectedGroup || this.props.uploadToGroupId || selectedAssignmentPool || this.props.uploadToAssignmentPoolId) {
      this.props.bulkUpload(
        [theFile],
        this.props.uploadToGroupId ? this.props.uploadToGroupId : selectedGroup ? selectedGroup.value : null,
        this.props.uploadToAssignmentPoolId ? this.props.uploadToAssignmentPoolId : selectedAssignmentPool ? selectedAssignmentPool.value : null
      ).then(() => {
        this.setState(startState)
      });
    } else {
      this.props.bulkUpload([theFile]).then(() => {
        this.setState(startState)
      })
    }
  };
  onStatusChange = (event) => {
    console.log('onStatusChange: ', event.affectedFiles, event.serverResponse)

    this.setState({
      ...this.state,
      files: event.newState,
    })
  }

  onUserFieldSelect = (vastField) => (selectedOption) => {
    this.setState({
      ...this.state,
      map: {
        ...this.state.map,
        [vastField]: selectedOption,
      },
    })
  }
  resetState = () => {
    this.setState(startState)
  }
  onConcatUserFieldSelect = (vastField, i) => (selectedOption) => {
    const concatArray = this.state.concat_map[vastField]
    concatArray[i] = selectedOption
    console.log(concatArray)
    this.setState({
      ...this.state,

      concat_map: {
        ...this.state.concat_map,
        [vastField]: concatArray,
      },
    })
  }
  onAddConcatFieldClick = (vastField) => {
    const concatArray = this.state.concat_map[vastField]
    concatArray.push('')
    console.log(concatArray)
    this.setState({
      ...this.state,

      concat_map: {
        ...this.state.concat_map,
        [vastField]: concatArray,
      },
    })
  }
  removeConcatFieldClick = (vastField, i) => {
    const concat_array = this.state.concat_map[vastField]

    if (i > -1) {
      concat_array.splice(i, 1)
      this.setState({
        ...this.state,

        concat_map: {
          ...this.state.concat_map,
          [vastField]: concat_array,
        },
      })
    }
  }
  render() {
    const { parsedFile, map, concat_map } = this.state
    const onConcatUserFieldSelect = this.onConcatUserFieldSelect
    const userFieldsSelectData =
      parsedFile && parsedFile.meta
        ? [...[{
          value: undefined,
          label: "Do Not Map"
        }], ...parsedFile.meta.fields.map((userField) => {
          return { value: userField, label: userField }
        })]
        : []
    const fuse = new Fuse(userFieldsSelectData, {
      includeScore: true,
      shouldSort: true,
      threshold: 0.35,
      location: 0,
      distance: 100,
      maxPatternLength: 32,
      minMatchCharLength: 1,
      keys: ['value'],
    })
    const customStyles = {
      control: (provided) => ({
        ...provided,
        borderColor: 'rgba(0, 0, 0, 0.23)',
        borderRadius: '20px',
        fontSize: '16px',
        padding: '4px 4px',
      }),
      menu: (provided) => ({
        ...provided,
        zIndex: 2,
      }),
    }

    //TODO: Combine FieldMapperRows and MobileFieldMapperRows to a single statement
    const FieldMapperRows =
      parsedFile && parsedFile.meta
        ? VastFields.map((vastField) => {
          let results = fuse.search(vastField.field)
          let synonym = false
          if (results.length === 0 && vastField.synonym1) {
            results = fuse.search(vastField.synonym1)
            if (results.length > 0) synonym = true
          }

          if (results.length === 0 && vastField.synonym2) {
            results = fuse.search(vastField.synonym2)
            if (results.length > 0) synonym = true
          }
          if (results.length === 0 && vastField.synonym3) {
            results = fuse.search(vastField.synonym3)
            if (results.length > 0) synonym = true
          }
          if (!map[vastField.field] && results[0]) {
            this.setState({
              ...this.state,
              map: {
                ...this.state.map,
                [vastField.field]: { ...results[0].item, predicted: synonym },
              },
            })
          }
          return (
            <TableRow key={vastField.field}>
              <TableCell>
                <ReactSelect
                  autoComplete={false}
                  onFocus={(e) => e.prev}
                  value={
                    map[vastField.field]
                      ? map[vastField.field]
                      : results[0]
                        ? results[0].item
                        : undefined
                  }
                  onChange={this.onUserFieldSelect(vastField.field)}
                  styles={customStyles}
                  options={userFieldsSelectData}
                />
                {concat_map[vastField.field] && (
                  <div
                    style={{
                      background: 'rgb(222, 222, 222)',
                      padding: 8,
                      borderRadius: 22,
                    }}
                  >
                    <div
                      onClick={() =>
                        this.onAddConcatFieldClick(vastField.field)
                      }
                      style={{ margin: 8, cursor: 'pointer' }}
                    >
                      + Click here to combine multiple Fields to make a{' '}
                      <strong>{vastField.text}</strong> field
                    </div>
                    {concat_map[vastField.field].map((value, i) => {
                      return (
                        <span>
                          <ReactSelect
                            key={`value${i}`}
                            value={value}
                            styles={customStyles}
                            onChange={onConcatUserFieldSelect(
                              vastField.field,
                              i,
                            )}
                            options={userFieldsSelectData}
                          />
                          <Button
                            style={{ fontSize: 8 }}
                            onClick={() =>
                              this.removeConcatFieldClick(vastField.field, i)
                            }
                          >
                            Remove
                          </Button>
                        </span>
                      )
                    })}
                  </div>
                )}
              </TableCell>
              <TableCell>
                <ArrowForwardIcon style={{ paddingTop: 5 }} />{' '}
                <span
                  style={{
                    fontSize: 20,
                    color: map[vastField.field]
                      ? map[vastField.field].predicted
                        ? 'orange'
                        : 'green'
                      : 'red',
                  }}
                >
                  {vastField.text}
                </span>
              </TableCell>
              <TableCell>{vastField.sample}</TableCell>
            </TableRow>
          )
        })
        : undefined

    const MobileFieldMapperRows =
      parsedFile && parsedFile.meta
        ? VastFields.map((vastField) => {
          let results = fuse.search(vastField.field)
          let synonym = false
          if (results.length === 0 && vastField.synonym1) {
            results = fuse.search(vastField.synonym1)
            if (results.length > 0) synonym = true
          }

          if (results.length === 0 && vastField.synonym2) {
            results = fuse.search(vastField.synonym2)
            if (results.length > 0) synonym = true
          }
          if (!map[vastField.field] && results[0]) {
            this.setState({
              ...this.state,
              map: {
                ...this.state.map,
                [vastField.field]: { ...results[0].item, predicted: synonym },
              },
            })
          }
          return (
            <Paper
              key={vastField.field}
              style={{ borderRadius: 28, marginBottom: 15 }}
            >
              <div style={{ marginBottom: 15 }}>
                <div style={{ float: 'left', width: '50%', padding: 10 }}>
                  <h3 style={{ marginTop: 5, marginBottom: 0 }}>
                    {language.contacts.add.csvFields}
                  </h3>
                </div>
                <div style={{ float: 'right', width: '50%', padding: 10 }}>
                  <h3 style={{ marginTop: 5, marginBottom: 0 }}>
                    {language.contacts.add.vastFields}
                  </h3>
                </div>
                <div style={{ clear: 'both' }}></div>
                <hr />
                <div style={{ float: 'left', width: '50%', padding: 10 }}>
                  <ReactSelect
                    value={
                      map[vastField.field]
                        ? map[vastField.field]
                        : results[0]
                          ? results[0].item
                          : undefined
                    }
                    onChange={this.onUserFieldSelect(vastField.field)}
                    styles={customStyles}
                    options={userFieldsSelectData}
                  />
                </div>
                <div style={{ float: 'right', width: '50%', padding: 10 }}>
                  <ArrowForwardIcon style={{ paddingTop: 5 }} />{' '}
                  <span
                    style={{
                      fontSize: 20,
                      color: map[vastField.field]
                        ? map[vastField.field].predicted
                          ? 'orange'
                          : 'green'
                        : 'red',
                    }}
                  >
                    {vastField.text}
                  </span>
                </div>
                <div style={{ clear: 'both' }}></div>
                {concat_map[vastField.field] && (
                  <div
                    style={{
                      background: 'rgb(222, 222, 222)',
                      padding: 8,
                      borderRadius: 22,
                      margin: 8,
                    }}
                  >
                    <div
                      onClick={() =>
                        this.onAddConcatFieldClick(vastField.field)
                      }
                      style={{ margin: 8, fontSize: 10, cursor: 'pointer' }}
                    >
                      + Add & combine multiple Fields to create a{' '}
                      <strong>{vastField.text}</strong> field
                    </div>
                    {concat_map[vastField.field].map((value, i) => {
                      return (
                        <span>
                          <ReactSelect
                            key={`value${i}`}
                            value={value}
                            styles={customStyles}
                            onChange={onConcatUserFieldSelect(
                              vastField.field,
                              i,
                            )}
                            options={userFieldsSelectData}
                          />
                          <Button
                            style={{ fontSize: 8 }}
                            onClick={() =>
                              this.removeConcatFieldClick(vastField.field, i)
                            }
                          >
                            Remove
                          </Button>
                        </span>
                      )
                    })}
                  </div>
                )}

                <hr />
                <div
                  style={{
                    float: 'left',
                    padding: '0 10px 10px 10px',
                    width: '50%',
                  }}
                >
                  <h3 style={{ margin: 0 }}>
                    {language.contacts.add.sampleData}
                  </h3>
                </div>
                <div style={{ float: 'right', width: '50%' }}>
                  <p style={{ margin: 0 }}> {vastField.sample}</p>
                </div>
                <div style={{ clear: 'both' }}></div>
              </div>
            </Paper>
          )
        })
        : undefined
    const { bulkUploadInProgress, bulkUploadStatus, groupOptions, createGroup, create, uploadToGroupId, groupsByID, uploadToAssignmentPoolId, assignmentPools, assignmentPoolsById } = this.props
    //add kendo spreadsheet so that people can preview the mapping and give them the option to
    const contactGroupSelector = (
      <span>
        <h4 style={{ margin: 16 }}>
          Select from the choices below to upload directly to a contact group
        </h4>
        <ReactSelect
          styles={{ customStyles }}
          onChange={(newValue, action) => {
            const that = this;
            if (action.action && action.action === 'create-option') {
              createGroup(newValue.value).then(function (group) {
                that.setState({
                  ...that.state,
                  selectedGroup: { value: group.id }
                });
              });
            } else {
              this.setState({
                ...this.state,
                selectedGroup: newValue
              });
            }
          }}
          closeMenuOnSelect
          isClearable={true}
          options={groupOptions}
          placeholder="Select a contact group or type in a new contact group name.  All contacts that are uploaded will be added to the contact group you select or create."
          creatable
        />
      </span>
    );

    const selectedGroupDisplay = (
      <p style={{ padding: 16 }}>
        These Contacts will upload to the contact group called{' '}
        <strong>{groupsByID[uploadToGroupId]?.name}</strong>
      </p>
    );
    const assignmentPoolSelector = (
      <span>
        <h4 style={{ margin: 16 }}>
          Select from the choices below to upload directly to an assignment pool
        </h4>
        <ReactSelect
          styles={{ customStyles }}
          onChange={(newValue, action) => {
            const that = this;
            if (action.action && action.action === 'create-option') {
              // Correct creation process for an assignment pool
              create({
                entity: {
                  name: newValue.value,
                  pool: {
                    users: Object.keys(this.props.users || {}).map(
                      username => ({ username }),
                    ),
                  },
                },
                entityType: 'account/ap',
              }).then(payload => {
                that.setState({
                  ...that.state,
                  selectedAssignmentPool: { value: payload.id }
                });
              });
            } else {
              this.setState({
                ...this.state,
                selectedAssignmentPool: newValue
              });
            }
          }}
          closeMenuOnSelect
          isClearable={true}
          options={assignmentPools}
          placeholder="Select an assignment pool or type in a new pool name. All contacts that are uploaded will be added to the assignment pool you select or create."
          creatable
        />
      </span>
    );

    const selectedAssignmentPoolDisplay = (
      <p style={{ padding: 16 }}>
        These Contacts will upload to the assignment pool called{' '}
        <strong>{assignmentPoolsById[uploadToAssignmentPoolId]?.name}</strong>
      </p>
    );
    return parsedFile ? (
      <div style={{ padding: 15 }}>
        <h3>{language.contacts.add.mapCsv}</h3>
        <p style={{ fontSize: 12 }}>
          {language.contacts.add.aiMatch}{' '}
          <em>{language.contacts.add.aiNote}</em>
        </p>

        <Hidden smDown>
          {bulkUploadInProgress ? (
            <div style={{ margin: '40px' }}>
              <h3>{language.contacts.add.fileProcessing}</h3>
              {bulkUploadStatus ? JSON.stringify(bulkUploadStatus) : null}{' '}
              <LinearProgress color="secondary" />
              {JSON.stringify(bulkUploadStatus)}
            </div>
          ) : (
            <div>
              <p>
                <Lens style={{ color: 'green' }} />{' '}
                <span
                  style={{
                    color: 'green',
                    fontSize: 16,
                    verticalAlign: 'top',
                    display: 'inline-block',
                    paddingTop: 5,
                    paddingRight: 15,
                  }}
                >
                  {language.contacts.add.confidentMatch}
                </span>
                <Lens style={{ color: 'orange' }} />{' '}
                <span
                  style={{
                    color: 'orange',
                    fontSize: 16,
                    verticalAlign: 'top',
                    display: 'inline-block',
                    paddingTop: 5,
                    paddingRight: 15,
                  }}
                >
                  {language.contacts.add.semiConfidentMatch}
                </span>
                <Lens style={{ color: 'red' }} />{' '}
                <span
                  style={{
                    color: 'red',
                    fontSize: 16,
                    verticalAlign: 'top',
                    display: 'inline-block',
                    paddingTop: 5,
                    paddingRight: 15,
                  }}
                >
                  {language.contacts.add.noMatch}
                </span>
              </p>
              <Paper>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell style={{ fontSize: 24 }}>
                        {language.contacts.add.yourFields}
                      </TableCell>
                      <TableCell style={{ fontSize: 24 }}>
                        {language.contacts.add.vastFields}
                      </TableCell>
                      <TableCell style={{ fontSize: 24 }}>
                        {language.contacts.add.sampleData}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>{FieldMapperRows}</TableBody>
                </Table>

                {!uploadToGroupId ? contactGroupSelector : selectedGroupDisplay}
                {!uploadToAssignmentPoolId ? assignmentPoolSelector : selectedAssignmentPoolDisplay}

                <Button
                  onClick={this.submitFile}
                  style={{ margin: 15 }}
                  variant="contained"
                  color="primary"
                >
                  {language.contacts.add.submitFile}
                </Button>
              </Paper>
            </div>
          )}
        </Hidden>
        <Hidden mdUp>
          {bulkUploadInProgress ? (
            <div style={{ margin: '40px' }}>
              <h3>{language.contacts.add.fileProcessing}</h3>
              <LinearProgress color="secondary" />
            </div>
          ) : (
            <div>
              <p>
                <Lens style={{ color: 'green', fontSize: 14 }} />{' '}
                <span
                  style={{
                    color: 'green',
                    fontSize: 12,
                    display: 'inline-block',
                    paddingRight: 15,
                  }}
                >
                  {language.contacts.add.yourFields}
                </span>
                <Lens style={{ color: 'orange', fontSize: 14 }} />{' '}
                <span
                  style={{
                    color: 'orange',
                    fontSize: 12,
                    display: 'inline-block',
                    paddingRight: 15,
                  }}
                >
                  {language.contacts.add.vastFields}
                </span>
                <Lens style={{ color: 'red', fontSize: 14 }} />{' '}
                <span
                  style={{
                    color: 'red',
                    fontSize: 12,
                    display: 'inline-block',
                    paddingRight: 15,
                  }}
                >
                  {language.contacts.add.sampleData}
                </span>
              </p>
              {MobileFieldMapperRows}
              {!uploadToGroupId ? contactGroupSelector : selectedGroupDisplay}
              {!uploadToAssignmentPoolId ? assignmentPoolSelector : selectedAssignmentPoolDisplay}

              <Button
                onClick={this.submitFile}
                variant="contained"
                color="primary"
              >
                {language.contacts.add.submitFile}
              </Button>
            </div>
          )}
        </Hidden>
      </div>
    ) : (
      <div style={{ padding: 15 }}>
        {/* TODO: make an array listview of statuses save by id in reducer"status":{"upload_id":"1588817273948202369","account_id":"43","entity_type":"Contact","job_status":"processing_started","file_name":"uploadIt.csv","success_count":0,"error_count":0,"source_prefix":"20200507020753"},"upload_id":"1588817273948202369","status_check_endpoint":"/upload/status/contacts/1588817273948202369"}
                    {"status":{"upload_id":"1588817273948202369","account_id":"43","entity_type":"Contact","job_status":"complete","file_name":"uploadIt.csv","success_count":94,"error_count":746,"source_prefix":"20200507020753"},"upload_id":"1588817273948202369"}
                    */}
        {bulkUploadStatus ? (
          Object.keys(bulkUploadStatus).length ? (
            <Paper>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>File Name</TableCell>
                    <TableCell align="right">Status</TableCell>
                    <TableCell align="right">
                      Number of contacts successfully added
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Object.keys(bulkUploadStatus).map((id) => (
                    <TableRow key={bulkUploadStatus[id].upload_id}>
                      <TableCell component="th" scope="row">
                        {bulkUploadStatus[id].file_name}
                      </TableCell>
                      <TableCell align="right">
                        {bulkUploadStatus[id].job_status.replace('_', ' ')}
                      </TableCell>
                      <TableCell align="right">
                        {bulkUploadStatus[id].success_count}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Paper>
          ) : null
        ) : null}
        <h2>{language.contacts.add.dragDropFile}</h2>
        {
          <Paper style={{ padding: '25px 0px', borderRadius: 28 }}>
            <Upload
              batch={false}
              multiple={false}
              onAdd={this.onAdd}
              onRemove={this.onRemove}
              onProgress={this.onProgress}
              onStatusChange={this.onStatusChange}
              withCredentials={false}
              autoUpload={false}
            />
          </Paper>
        }
      </div>
    )
  }
}
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withStyles(styles)(BulkUploadMapper)),
)
